import {
  ORDER_CUTOFF_INSTRUCTIONS_LABEL,
  ORDER_CUTOFF_TIME_LABEL,
} from './supplierOrderCutOff'

export const VENUE_SUPPLIERS_LOCKED_COLUMN_KEYS = ['supplierTitle', 'actions']

export const VENUE_SUPPLIERS_OPTIONAL_COLUMN_DEFS = [
  { key: 'secondTitle', label: 'Second title', requiresAdmin: true },
  { key: 'accountNumber', label: 'Account number' },
  { key: 'minOrderValue', label: 'Minimum order' },
  { key: 'deliveryFee', label: 'Delivery Fee' },
  { key: 'deliveryDays', label: 'Delivery days' },
  {
    key: 'allowsCreditPurchase',
    label: 'Credit status',
    requiresCredit: true,
  },
  { key: 'supplierOrderCutOffTime', label: ORDER_CUTOFF_TIME_LABEL },
  {
    key: 'orderCutOffInstructions',
    label: ORDER_CUTOFF_INSTRUCTIONS_LABEL,
  },
  { key: 'priceFileStatus', label: 'Price File Status' },
  { key: 'phoneNumber', label: 'Phone number' },
]

const prefsKey = venueId =>
  `oms.venueSuppliers.hiddenColumns.${String(venueId || '').trim()}`

export const isVenueSuppliersColumnLocked = key =>
  VENUE_SUPPLIERS_LOCKED_COLUMN_KEYS.includes(String(key || ''))

export const venueSuppliersColumnLabel = column => {
  const key = String(column?.key || '')
  const fromDefs = VENUE_SUPPLIERS_OPTIONAL_COLUMN_DEFS.find(
    item => item.key === key,
  )
  if (fromDefs?.label) return fromDefs.label
  if (typeof column?.title === 'string' && column.title.trim()) {
    return column.title.trim()
  }
  return key
}

export const listVenueSuppliersOptionalColumns = (
  columns = VENUE_SUPPLIERS_OPTIONAL_COLUMN_DEFS,
  { showAdmin = false, showCredit = false } = {},
) =>
  (Array.isArray(columns) ? columns : [])
    .filter(column => {
      if (!column?.key || isVenueSuppliersColumnLocked(column.key)) return false
      if (column.requiresAdmin && !showAdmin) return false
      if (column.requiresCredit && !showCredit) return false
      return true
    })
    .map(column => ({
      key: String(column.key),
      label: venueSuppliersColumnLabel(column),
    }))

export const loadVenueSuppliersHiddenColumns = venueId => {
  if (typeof window === 'undefined' || !window.localStorage) return null
  try {
    const raw = window.localStorage.getItem(prefsKey(venueId))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return null
    return parsed.map(String).filter(key => !isVenueSuppliersColumnLocked(key))
  } catch (error) {
    return null
  }
}

export const saveVenueSuppliersHiddenColumns = (venueId, hiddenKeys = []) => {
  if (typeof window === 'undefined' || !window.localStorage) return
  const next = (Array.isArray(hiddenKeys) ? hiddenKeys : [])
    .map(String)
    .filter(key => !isVenueSuppliersColumnLocked(key))
  window.localStorage.setItem(prefsKey(venueId), JSON.stringify(next))
}

export const toggleVenueSuppliersHiddenColumn = (hiddenKeys, columnKey) => {
  const key = String(columnKey || '')
  if (!key || isVenueSuppliersColumnLocked(key)) {
    return Array.isArray(hiddenKeys) ? [...hiddenKeys] : []
  }
  const current = new Set(
    (Array.isArray(hiddenKeys) ? hiddenKeys : []).map(String),
  )
  if (current.has(key)) current.delete(key)
  else current.add(key)
  return [...current]
}

export const filterVenueSuppliersVisibleColumns = (
  columns = [],
  { hiddenKeys } = {},
) => {
  const list = (Array.isArray(columns) ? columns : []).filter(
    column => column && column.key,
  )
  if (!Array.isArray(hiddenKeys)) {
    return list
  }
  const hidden = new Set(hiddenKeys.map(String))
  return list.filter(
    column =>
      isVenueSuppliersColumnLocked(column.key) ||
      !hidden.has(String(column.key)),
  )
}
